import { mapGetters } from 'vuex'
import EnvelopeDataService from '@/services/EnvelopeDataService'

export default {
  name: 'ManageEnvelope',
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'Nom',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      { text: 'Description', value: 'description' },
      { type: 'select', text: 'Periodicite', value: 'periodicite' },
      { text: 'Montant', value: 'montant' },
      { text: 'Seuil', value: 'seuil' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    listPeriodicite: ['semaine', 'mois', 'annee'],
    envelopes: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      description: '',
      periodicite: '',
      montant: '',
      seuil: 75
    },
    defaultItem: {
      name: '',
      description: '',
      periodicite: '',
      montant: '',
      seuil: 75
    },
    isMobile: false,
    isValid: true,
    message: '',
    dismissSecs: 4,
    dismissCountDownSuccess: 0
  }),

  computed: {
    ...mapGetters(['isLogged']),
    formTitle () {
      return this.editedIndex === -1 ? 'Nouvelle enveloppe' : 'Modifier enveloppe'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    }
  },

  created () {
    this.initialize()
  },

  mounted () {
    this.onResize()

    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    countDownChangedSuccess (dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },

    showSuccess () {
      this.dismissCountDownSuccess = this.dismissSecs
    },

    getDisplayEnvelope (envelope) {
      return {
        id: envelope.id,
        name: envelope.name,
        description: envelope.description.length > 60 ? envelope.description.substr(0, 60) + '...' : envelope.description,
        periodicite: envelope.periodicite,
        montant: envelope.montant,
        seuil: envelope.seuil
      }
    },

    initialize () {
      EnvelopeDataService.getAll()
        .then((response) => {
          this.envelopes = response.data.content.map(this.getDisplayEnvelope)
        })
        .catch((e) => {
          console.log(e)
        })
    },

    onResize () {
      this.isMobile = window.innerWidth < 769
    },

    editItem (item) {
      this.editedIndex = this.envelopes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.envelopes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      // supprimer une enveloppe
      EnvelopeDataService.delete(this.editedItem)
        .then(response => {
          this.message = response.data.status_message
          this.showSuccess()
        })
      this.envelopes.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.envelopes[this.editedIndex], this.editedItem)

        // mettre à jour une enveloppe
        EnvelopeDataService.update(this.editedItem)
          .then(response => {
            this.message = response.data.status_message
            this.showSuccess()
          })
      } else {
        this.envelopes.push(this.editedItem)

        // créer une enveloppe
        EnvelopeDataService.create(this.editedItem)
      }

      this.close()
    }
  }
}
